import { render } from "./DoctorOrderList.vue?vue&type=template&id=72012653"
import script from "./DoctorOrderList.vue?vue&type=script&lang=js"
export * from "./DoctorOrderList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__